import * as angular from "angular";
import { SubscriptionDataProvider } from "../../data-provider/subscription.dp";
import { DialogUtils } from "../../helper/dialog.helper";

let ViewInvoiceDialog = {
    selector: "vcViewInvoiceDialog",
    templateUrl: "/angular/components/profile/view-invoice.component.html",
    bindings: {
        campaign: "=",
    },
    controller: class ViewInvoiceDialogController {
        // * bindings for typescript compiler *
        public campaign: any;
        // ************************************

        public campaignError = false;

        private dialog: DialogUtils;
        private subscriptionDataProvider: SubscriptionDataProvider;

        constructor(
            DialogUtils: DialogUtils,
            SubscriptionDataProvider: SubscriptionDataProvider
        ) {
            this.dialog = DialogUtils;
            this.subscriptionDataProvider = SubscriptionDataProvider;
        }

        $onInit() {
            this.loadInvoices();
        }

        loadInvoices(): void {
            this.campaign.invoices = {};
            this.campaign.loadingInvoices = true;
            this.subscriptionDataProvider.invoices().then((json: any) => {
                this.campaign.loadingInvoices = false;
                if (json.invoices) {
                    this.campaign.invoices = json.invoices;
                    this.campaign.next_payment = json.next_payment;
                } else {
                    this.campaignError = true;
                }
            });
        }

        close(): void {
            this.dialog.cancel();
        }
    },
};

angular
    .module("profile")
    .component(ViewInvoiceDialog.selector, ViewInvoiceDialog);
